import { createUseStyles } from "react-jss";
import { Z } from "../../styles/zIndex";
const useStyles = createUseStyles({
  container: {
    position: "fixed",
    width: "100%",
    height: "var(--app-vh)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgb(0, 0, 0, 0.4)",
    zIndex: Z.LOADER,
  },
});
export default useStyles;
